import { sendWebsocketMessage } from '../../../../../App';

export function addWatchlistName(name) {
  const msg = {
    messageType: 'addWatchlistName',
    name,
  };
  sendWebsocketMessage(msg);
}
